import {
    PACKAGES_CREATE_EDIT_OPEN_MODAL,
    PACKAGES_CREATE_PACKAGE_REQUEST,
    PACKAGES_CREATE_PACKAGE_RESULT,
    PACKAGES_UPDATE_PACKAGE_REQUEST,
    PACKAGES_UPDATE_PACKAGE_RESULT,
    PACKAGES_GET_PACKAGE_REQUEST,
    PACKAGES_GET_PACKAGE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    loading: false,
    create: null,
    update: null,
    role: null,
    roleinfo: null
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case PACKAGES_GET_PACKAGE_REQUEST:
            return { ...state, loading: true }

        case PACKAGES_GET_PACKAGE_RESULT:
            return { ...state, loading: false, roleinfo: action.payload }

        case PACKAGES_CREATE_EDIT_OPEN_MODAL:
            return { ...state, openModal: true, role: action.payload }

        case PACKAGES_CREATE_PACKAGE_REQUEST:
            return { ...state, loading: true }

        case PACKAGES_CREATE_PACKAGE_RESULT:
            return { ...state, loading: false, create: action.payload }

        case PACKAGES_UPDATE_PACKAGE_REQUEST:
            return { ...state, loading: true }

        case PACKAGES_UPDATE_PACKAGE_RESULT:
            return { ...state, loading: false, update: action.payload }

        case CLEAR_REDUX:
            return ["", "CREATE_EDIT_PACKAGE"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};